import React from "react";
import { 
  MarkCampaignController, 
  useMyIdentities, 
  ViewMe 
} from "@njoy/controller";

import CampaignAdModal from "../../components/modals/campaignAdModal";
import SurveyModal from "../../components/modals/surveyModal";
import ToastMessage from "../../hooks/useToast";
import { useCampaignFlow } from "./CampaignFlowContext";

const CampaignHost: React.FC = () => {
  const { campaign, completeCampaign, dismissCampaign } = useCampaignFlow();

  const { myIdentities } = useMyIdentities({
    offset: 0,
    limit: 1,
  });

  if (!campaign) {
    return null;
  }

  return (
    <ViewMe>
      {(data) => (
        <MarkCampaignController>
          {({ submit }) => {
            const getErrorMessage = (errors: ({ path: string; message: string } | null)[] | null) =>
              errors?.find((error) => Boolean(error?.message))?.message || "Unable to mark campaign";

            const markAndCloseCampaign = async () => {
              const res = await submit({
                id: campaign.id,
                option: null,
                close: true,
              });

              if (res.errors) {
                ToastMessage("error", getErrorMessage(res.errors));
                return;
              }

              dismissCampaign();
            };

            const markAdvertClick = async () => {
              const res = await submit({
                id: campaign.id,
                option: null,
              });

              if (res.errors) {
                ToastMessage("error", getErrorMessage(res.errors));
                return;
              }

              completeCampaign();
              ToastMessage("success", res.message || "");
            };

            const markPollSubmit = async (option: string) => {
              const res = await submit({
                id: campaign.id,
                option,
              });

              if (res.errors) {
                ToastMessage("error", getErrorMessage(res.errors));
                return;
              }

              completeCampaign();
              ToastMessage("success", res.message || "");
            };

            if (campaign.campaignType === "Advert") {
              return (
                <CampaignAdModal
                  visible
                  onCancel={markAndCloseCampaign}
                  adCaption={campaign.description}
                  adImage={campaign.bannerUrl}
                  adLink={campaign.campaignLink}
                  adTitle={campaign.title}
                  onClick={markAdvertClick}
                />
              );
            }

            if (campaign.campaignType === "Poll") {
              return (
                <SurveyModal
                  userName={
                    data.match?.customer?.firstname ||
                    myIdentities?.[0]?.name?.split(" ")[0] ||
                    "there"
                  }
                  visible
                  onCancel={markAndCloseCampaign}
                  question={campaign.question}
                  pollOptions={campaign.pollOptions}
                  onSubmit={markPollSubmit}
                />
              );
            }

            return null;
          }}
        </MarkCampaignController>
      )}
    </ViewMe>
  );
};

export default CampaignHost;
